import React from 'react';

/**
 * Превращает строку с разметкой [текст](url) в массив React-узлов
 * Пример: "Согласен с [офертой](/terms-of-service) и правилами"
 */
export function parseLinks(text: string | null | undefined): React.ReactNode[] {
  if (!text) return [];
  const re = /\[([^\]]+)\]\(([^)]+)\)/g;
  const out: React.ReactNode[] = [];
  let lastIndex = 0;
  let match: RegExpExecArray | null;
  let key = 0;

  while ((match = re.exec(text)) !== null) {
    if (match.index > lastIndex) {
      out.push(text.slice(lastIndex, match.index));
    }
    const [, label, href] = match;
    out.push(
      <a
        key={key++}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-mystic-400 hover:text-mystic-300 underline transition-colors"
      >
        {label}
      </a>
    );
    lastIndex = match.index + match[0].length;
  }

  if (lastIndex < text.length) {
    out.push(text.slice(lastIndex));
  }
  return out;
}
